import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { updateReimbursementReport } from "~/providers/api/reimbursementReport";
import { ReimbursementReportData } from "~/providers/utils/types/consultation";

interface UseUpdateReimbursementReportProps {
  consultationId?: string;
  showSuccessMessage?: boolean;
}

export const useUpdateReimbursementReport = ({
  consultationId,
  showSuccessMessage,
}: UseUpdateReimbursementReportProps) => {
  const queryClient = useQueryClient();

  const { mutate: updateReimbursementReportMutation, isPending } = useMutation({
    mutationFn: (reportData: ReimbursementReportData) =>
      updateReimbursementReport({ data: reportData }, consultationId),
    onError: () =>
      toast.error(
        "We shoot trouble updating the progress note, if the issue persists please reload the page!",
      ),
    onSuccess: async () => {
      showSuccessMessage &&
        toast.success("Progress note updated successfully!");
      await queryClient.invalidateQueries({
        queryKey: ["getReimbursementReport", consultationId],
      });
    },
  });

  return { updateReimbursementReportMutation, isPending };
};
